(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somdul-brand-system"]) return;
  try {
    
  function somdulCloseMobileMenu(drawer, event, focusTarget) {
    const details = drawer?.querySelector('details');
    if (!details?.open || typeof drawer.closeMenuDrawer !== 'function') return;
    drawer.closeMenuDrawer(event, focusTarget);
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  const somdulDesktopHeader = window.matchMedia('(min-width: 990px)');
  somdulDesktopHeader.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('.somdul-header > header-drawer[data-breakpoint="tablet"]').forEach((drawer) => {
      const header = drawer.closest('.somdul-header');
      somdulCloseMobileMenu(drawer, event, header.querySelector('.header__heading-link'));
    });
  });

  document.addEventListener('click', (event) => {
    const header = event.target.closest?.('.somdul-header');
    if (!header || somdulDesktopHeader.matches) return;
    const drawer = header.querySelector('header-drawer');
    if (!drawer || drawer.contains(event.target)) return;
    const target = event.target.closest('summary, button, a, shopify-account') || header.querySelector('.header__heading-link');
    somdulCloseMobileMenu(drawer, event, target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somdul-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('somdul-catalog')) {
    customElements.define('somdul-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('[data-product-grid]');
        this.viewControls = this.querySelector('[data-view-controls]');
        if (this.grid && this.viewControls) {
          this.viewControls.hidden = false;
          this.viewControls.addEventListener('click', event => {
            const button = event.target.closest('[data-view]');
            if (!button) return;
            this.grid.dataset.layout = button.dataset.view;
            this.viewControls.querySelectorAll('[data-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          });
        }
        this.filters = this.querySelector('.sc__filters');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onBreakpoint = () => { this.filters.open = !this.mobileQuery.matches; };
        this.onBreakpoint();
        this.mobileQuery.addEventListener('change', this.onBreakpoint);
        this.querySelector('[data-live-sort]')?.addEventListener('change', event => event.target.form?.requestSubmit());
        if (this.dataset.preview !== 'true') return;
        this.category = ['sauces', 'curry', 'seasonings', 'kits'].includes(this.dataset.initialCategory) ? this.dataset.initialCategory : 'all';
        this.pack = 'any';
        this.searchText = '';
        this.demoCards = Array.from(this.querySelectorAll('[data-demo-category]'));
        this.categoryLinks = Array.from(this.querySelectorAll('[data-preview-category]'));
        this.querySelector('[data-preview-controls]').disabled = false;
        this.querySelector('[data-search-input]').disabled = false;
        this.querySelector('[data-preview-search-button]').disabled = false;
        this.querySelector('[data-preview-search-button]').addEventListener('click', () => this.filterExamples());
        this.querySelector('[data-search-input]').addEventListener('input', event => {
          this.searchText = event.target.value.trim().toLocaleLowerCase();
          this.filterExamples();
        });
        this.categoryLinks.forEach(link => link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.category = link.dataset.previewCategory;
          this.filterExamples();
        }));
        this.querySelector('[data-preview-controls]').addEventListener('change', event => {
          if (event.target.matches('input[type="radio"]')) {
            this.pack = event.target.value;
            this.filterExamples();
          }
        });
        this.querySelector('[data-preview-reset]').addEventListener('click', () => {
          this.category = 'all';
          this.pack = 'any';
          this.searchText = '';
          this.querySelector('[data-search-input]').value = '';
          this.querySelector('[data-preview-controls] input[value="any"]').checked = true;
          this.filterExamples();
        });
        this.filterExamples();
      }
      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.onBreakpoint);
      }
      filterExamples() {
        let count = 0;
        this.demoCards.forEach(card => {
          const searchMatches = !this.searchText || card.querySelector('.sc-card__body').textContent.toLocaleLowerCase().includes(this.searchText);
          const visible = (this.category === 'all' || card.dataset.demoCategory === this.category) && (this.pack === 'any' || card.dataset.demoPack === this.pack) && searchMatches;
          card.hidden = !visible;
          if (visible) count += 1;
        });
        let title = this.dataset.allTitle;
        this.categoryLinks.forEach(link => {
          if (link.dataset.previewCategory === this.category) {
            link.setAttribute('aria-current', 'page');
            title = link.dataset.categoryTitle;
          } else link.removeAttribute('aria-current');
        });
        this.querySelector('[data-catalog-title]').textContent = title;
        this.querySelector('[data-preview-breadcrumb]').textContent = title;
        this.querySelector('[data-result-count]').textContent = this.dataset.previewCount.replace('[count]', String(count));
        this.querySelector('[data-preview-empty]').hidden = count > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somdul-checkout-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('somdul-checkout-preview')) {
  customElements.define('somdul-checkout-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.step = 'cart';
      this.completed = false;
      this.itemLabels = new Map();
      this.querySelectorAll('[data-scp-item-label]').forEach(element => this.itemLabels.set(element.dataset.scpItemLabel, element.textContent.trim()));
      this.querySelectorAll('[data-somdul-sample]').forEach(element => this.itemLabels.set(element.dataset.somdulSample, element.dataset.label || element.textContent.trim()));
      this.allowedItems = Array.from(this.itemLabels.keys());
      this.allowedPacks = ['single','case','foodservice'];
      this.rows = this.defaultRows();
      this.querySelectorAll('button[disabled], fieldset[disabled]').forEach(control => control.disabled = false);
      this.bindEvents();
      this.readSelection();
      this.renderRows();
      this.updateStep();
    }
    message(key) { return this.getAttribute('data-msg-' + key.replaceAll('_','-')) || ''; }
    defaultRows() { return [{item:'sauce',pack:'single',quantity:1},{item:'curry',pack:'single',quantity:2},{item:'seasoning',pack:'single',quantity:1}]; }
    normalizeRows(rows) {
      if (!Array.isArray(rows)) return [];
      const valid = [];
      rows.slice(0,12).forEach(row => {
        if (!row || !this.allowedItems.includes(row.item) || !this.allowedPacks.includes(row.pack)) return;
        const quantity = Number(row.quantity);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) return;
        const match = valid.find(existing => existing.item === row.item && existing.pack === row.pack);
        if (match) match.quantity = Math.min(99, match.quantity + quantity);
        else valid.push({item:row.item,pack:row.pack,quantity});
      });
      return valid;
    }
    getCartState() { return this.rows.map(row => ({...row})); }
    setCartState(rows) { this.rows = this.normalizeRows(rows); this.completed = false; this.step = 'cart'; this.renderRows(); this.updateStep(); }
    importSelection(item, pack, quantity) {
      if (!this.allowedItems.includes(item)) return false;
      const selectedPack = this.allowedPacks.includes(pack) ? pack : 'single';
      const count = Number(quantity);
      const selectedQuantity = Number.isInteger(count) && count >= 1 && count <= 99 ? count : 1;
      this.setCartState([{item,pack:selectedPack,quantity:selectedQuantity}]);
      return true;
    }
    readSelection() {
      const params = new URLSearchParams(window.location.search);
      if (params.has('items')) {
        const raw = params.get('items') || '';
        if (raw === 'empty') { this.rows = []; return; }
        const entries = raw.slice(0,600).split(',').map(token => { const [item,pack,quantity] = token.split('.'); return {item,pack,quantity}; });
        const valid = this.normalizeRows(entries);
        if (valid.length) this.rows = valid;
        return;
      }
      const item = params.get('item');
      if (this.allowedItems.includes(item)) {
        const pack = this.allowedPacks.includes(params.get('pack')) ? params.get('pack') : 'single';
        const count = Number(params.get('quantity'));
        this.rows = [{item,pack,quantity:Number.isInteger(count) && count >= 1 && count <= 99 ? count : 1}];
      }
    }
    label(type, value) { return type === 'item' ? this.itemLabels.get(value) : this.querySelector('[data-scp-' + type + '-label="' + value + '"]').textContent.trim(); }
    bindEvents() {
      this.querySelectorAll('[data-scp-step]').forEach(button => button.addEventListener('click', () => this.goStep(button.dataset.scpStep)));
      this.querySelector('[data-scp-next]').addEventListener('click', () => {
        if (this.step === 'cart') this.goStep('delivery');
        else if (this.step === 'delivery') this.goStep('payment');
        else this.finish();
      });
      this.querySelector('[data-scp-delivery-next]').addEventListener('click', () => this.goStep('payment'));
      this.querySelector('[data-scp-finish]').addEventListener('click', () => this.finish());
      this.querySelector('[data-scp-fill]').addEventListener('click', () => {
        const sample = {first_name:this.message('sample_first'),last_name:this.message('sample_last'),email:'preview@example.com',address:this.message('sample_address'),apartment:'',city:this.message('sample_city'),state:'CA',zip:'00000'};
        this.querySelectorAll('[data-scp-field]').forEach(field => { field.value = sample[field.dataset.scpField] || ''; this.clearError(field); });
        this.announce(this.message('sample_filled'));
      });
      this.querySelectorAll('[data-scp-field]').forEach(field => {
        field.addEventListener('input', () => { if (field.getAttribute('aria-invalid') === 'true') this.clearError(field); });
        field.addEventListener('change', () => this.clearError(field));
      });
      this.querySelector('[data-scp-apply]').addEventListener('click', () => {
        const code = this.querySelector('[data-scp-promo]');
        const hasCode = Boolean(code.value.trim());
        this.querySelector('[data-scp-promo-message]').textContent = this.message(hasCode ? 'promo_feedback' : 'promo_required');
        code.setAttribute('aria-invalid', String(!hasCode));
        if (!hasCode) code.focus();
      });
      this.querySelector('[data-scp-restore]').addEventListener('click', () => { this.setCartState(this.defaultRows()); this.focusHeading('cart'); });
      this.querySelector('[data-scp-restart]').addEventListener('click', () => this.restart());
      this.querySelector('[data-scp-edit]').addEventListener('click', () => { this.completed = false; this.step = 'cart'; this.updateStep(); this.focusHeading('cart'); });
      this.querySelector('[data-scp-rows]').addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        const rowNode = button.closest('[data-scp-row]');
        if (!rowNode) return;
        const index = Number(rowNode.dataset.scpRow);
        const row = this.rows[index];
        if (!row) return;
        if (button.hasAttribute('data-scp-remove')) {
          this.rows.splice(index,1); this.renderRows();
          const next = this.querySelectorAll('[data-scp-remove]')[Math.min(index,this.rows.length-1)];
          if (next) next.focus(); else this.querySelector('[data-scp-restore]').focus();
          this.announce(this.message('removed'));
          return;
        }
        const change = button.hasAttribute('data-scp-minus') ? -1 : 1;
        row.quantity = Math.max(1,Math.min(99,row.quantity + change));
        this.updateRow(rowNode,row); this.updateSummary(); this.announce(this.message('updated'));
      });
      this.querySelector('[data-scp-rows]').addEventListener('change', event => {
        const input = event.target.closest('[data-scp-quantity]');
        if (!input) return;
        const rowNode = input.closest('[data-scp-row]');
        const row = this.rows[Number(rowNode.dataset.scpRow)];
        const count = Number(input.value);
        if (!Number.isInteger(count) || count < 1 || count > 99) { input.value = row.quantity; this.announce(this.message('quantity_error')); return; }
        row.quantity = count; this.updateRow(rowNode,row); this.updateSummary(); this.announce(this.message('updated'));
      });
    }
    renderRows() {
      const list = this.querySelector('[data-scp-rows]');
      list.replaceChildren();
      const template = this.querySelector('[data-scp-row-template]');
      this.rows.forEach((row,index) => {
        const node = template.content.firstElementChild.cloneNode(true);
        node.dataset.scpRow = index;
        const title = this.label('item',row.item);
        node.querySelector('[data-scp-item-title]').textContent = title;
        node.querySelector('[data-scp-pack]').textContent = this.label('pack',row.pack);
        const input = node.querySelector('[data-scp-quantity]');
        input.id = this.querySelector('[data-scp-heading="cart"]').id + '-quantity-' + index;
        const label = node.querySelector('[data-scp-quantity-label]');
        label.htmlFor = input.id; label.textContent += ' — ' + title;
        const remove = node.querySelector('[data-scp-remove]');
        remove.setAttribute('aria-label', remove.textContent + ' — ' + title);
        ['minus','plus'].forEach(action => { const button = node.querySelector('[data-scp-' + action + ']'); button.setAttribute('aria-label',button.getAttribute('aria-label') + ' — ' + title); });
        this.updateRow(node,row);
        list.append(node);
      });
      this.updateSummary();
    }
    updateRow(node,row) {
      node.querySelector('[data-scp-quantity]').value = row.quantity;
      node.querySelector('[data-scp-minus]').disabled = row.quantity <= 1;
      node.querySelector('[data-scp-plus]').disabled = row.quantity >= 99;
    }
    updateSummary() {
      const empty = this.rows.length === 0;
      this.querySelector('[data-scp-empty]').hidden = !empty;
      this.querySelector('[data-scp-count]').textContent = this.rows.reduce((total,row) => total + row.quantity,0);
      this.querySelectorAll('[data-scp-next], [data-scp-delivery-next], [data-scp-finish]').forEach(button => button.disabled = empty);
      this.querySelectorAll('[data-scp-step]').forEach(button => button.disabled = empty && button.dataset.scpStep !== 'cart');
      if (empty) { this.step = 'cart'; this.updateStep(); }
      this.syncLanguageReturn();
    }
    syncLanguageReturn() {
      if (this.hidden || this.closest('[hidden]')) return;
      const params = new URLSearchParams();
      params.set('view','checkout-preview');
      params.set('items',this.rows.length ? this.rows.map(row => [row.item,row.pack,row.quantity].join('.')).join(',') : 'empty');
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) params.set('preview_theme_id',preview);
      const destination = window.location.pathname + '?' + params.toString();
      document.querySelectorAll('form[action*="/localization"] input[name="return_to"]').forEach(input => { input.value = destination; });
      this.dispatchEvent(new CustomEvent('somdul:preview-cart-change',{bubbles:true,detail:{items:this.getCartState()}}));
    }
    announce(message) { this.querySelector('[data-scp-status]').textContent = message; }
    clearError(field) {
      field.removeAttribute('aria-invalid');
      const error = this.querySelector('[data-scp-error="' + field.dataset.scpField + '"]');
      error.hidden = true; error.textContent = '';
    }
    validateDelivery() {
      let firstError = null;
      this.querySelectorAll('[data-scp-field]').forEach(field => {
        this.clearError(field);
        const value = field.value.trim();
        let message = '';
        if (field.required && !value) message = this.message('required_error');
        else if (field.dataset.scpField === 'email' && value && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || !field.validity.valid)) message = this.message('email_error');
        else if (field.dataset.scpField === 'zip' && value && !/^\d{5}(-\d{4})?$/.test(value)) message = this.message('zip_error');
        if (!message) return;
        field.setAttribute('aria-invalid','true');
        const error = this.querySelector('[data-scp-error="' + field.dataset.scpField + '"]');
        error.textContent = message; error.hidden = false;
        if (!firstError) firstError = field;
      });
      if (firstError) { this.step = 'delivery'; this.updateStep(); firstError.focus(); return false; }
      return true;
    }
    goStep(step) {
      if (!['cart','delivery','payment'].includes(step) || (step !== 'cart' && !this.rows.length)) return;
      if (step === 'payment' && !this.validateDelivery()) return;
      this.completed = false; this.step = step; this.updateStep(); this.focusHeading(step); this.announce(this.message('progress_' + step));
    }
    focusHeading(step) {
      const heading = this.querySelector('[data-scp-heading="' + step + '"]');
      heading.focus({preventScroll:true});
      const section = heading.closest('section');
      if (section && typeof section.scrollIntoView === 'function') section.scrollIntoView({behavior:'auto',block:'start'});
    }
    updateStep() {
      this.querySelector('[data-scp-layout]').hidden = this.completed;
      this.querySelector('[data-scp-complete]').hidden = !this.completed;
      this.querySelectorAll('[data-scp-step]').forEach(button => {
        if (button.dataset.scpStep === this.step) button.setAttribute('aria-current','step');
        else button.removeAttribute('aria-current');
      });
      this.querySelector('[data-scp-next]').textContent = this.message(this.step === 'cart' ? 'continue_delivery' : this.step === 'delivery' ? 'continue_payment' : 'finish');
    }
    finish() {
      if (!this.rows.length || !this.validateDelivery()) return;
      this.step = 'payment'; this.completed = true; this.updateStep(); this.announce('');
      const heading = this.querySelector('[data-scp-complete] h2'); heading.focus();
      if (typeof heading.scrollIntoView === 'function') heading.scrollIntoView({behavior:'auto',block:'center'});
    }
    restart() {
      this.querySelectorAll('[data-scp-field]').forEach(field => { field.value = ''; this.clearError(field); });
      this.querySelector('[data-scp-promo]').value = '';
      this.querySelector('[data-scp-promo]').removeAttribute('aria-invalid');
      this.querySelector('[data-scp-promo-message]').textContent = '';
      this.querySelector('[data-scp-methods] input[value="standard"]').checked = true;
      this.setCartState(this.defaultRows()); this.announce(''); this.focusHeading('cart');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somdul-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-somdul-newsletter-popup]').forEach((dialog) => {
        if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
        dialog.dataset.initialized = 'true';
        const form = dialog.querySelector('form');
        const state = dialog.querySelector('[data-popup-form-state]');
        const signup = dialog.querySelector('[data-popup-signup]');
        const success = dialog.querySelector('[data-popup-success]');
        const email = dialog.querySelector('input[type="email"]');
        const dismissButton = dialog.querySelector('[data-popup-dismiss]');
        const dismissedKey = 'somdul:newsletter:dismissed:v1';
        const completedKey = 'somdul:newsletter:completed:v1';
        const attemptKey = 'somdul:newsletter:attempt:v1';
        const month = 30 * 24 * 60 * 60 * 1000;
        let opener = null;
        let confirmedHere = false;
        let autoTimer;
        const read = (kind, key) => {
          try { return window[kind].getItem(key); } catch (_) { return null; }
        };
        const write = (kind, key, value) => {
          try { window[kind].setItem(key, String(value)); } catch (_) {}
        };
        const remove = (kind, key) => {
          try { window[kind].removeItem(key); } catch (_) {}
        };
        const dismiss = () => {
          write('localStorage', dismissedKey, Date.now());
          if (dialog.open) dialog.close();
        };
        const open = (trigger) => {
          if (dialog.open || !dialog.isConnected) return;
          opener = trigger || document.activeElement;
          clearTimeout(autoTimer);
          dialog.showModal();
          document.documentElement.classList.add('somdul-newsletter-open');
          if (confirmedHere) dialog.querySelector('[data-popup-success-title]')?.focus();
        };
        dialog.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', dismiss));
        dialog.addEventListener('cancel', () => write('localStorage', dismissedKey, Date.now()));
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('somdul-newsletter-open');
          if (opener?.isConnected && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
        });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
        });
        const current = new URL(window.location.href);
        form.addEventListener('submit', () => {
          write('sessionStorage', attemptKey, Date.now());
        });
        const pendingAt = Number(read('sessionStorage', attemptKey));
        const freshAttempt = pendingAt > 0 && Date.now() - pendingAt < 30 * 60 * 1000;
        const hashMatches = current.hash === '#' + dialog.id || current.hash === '#' + form.id;
        const belongsToPopup = hashMatches || (!current.hash && freshAttempt);
        if (belongsToPopup && state.dataset.status === 'success' && success) {
          confirmedHere = true;
          signup.hidden = true;
          success.hidden = false;
          dismissButton.hidden = true;
          write('localStorage', completedKey, Date.now());
          remove('sessionStorage', attemptKey);
          open();
        } else if (belongsToPopup && state.dataset.status === 'error') {
          const errors = dialog.querySelector('[data-popup-errors]');
          if (errors) {
            errors.hidden = false;
            email.setAttribute('aria-invalid', 'true');
            email.setAttribute('aria-describedby', errors.id);
          }
          remove('sessionStorage', attemptKey);
          open();
        }
        dialog.querySelector('[data-popup-copy]')?.addEventListener('click', async () => {
          const code = dialog.querySelector('[data-popup-code]');
          const status = dialog.querySelector('[data-popup-copy-status]');
          try {
            await navigator.clipboard.writeText(code.textContent.trim());
            status.textContent = dialog.dataset.copySuccess;
          } catch (_) {
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            status.textContent = dialog.dataset.copyFallback;
          }
        });
        dialog.addEventListener('somdul:newsletter:open', (event) => open(event.detail?.trigger));
        document.querySelectorAll('[data-somdul-popup-open]').forEach((trigger) => { trigger.hidden = false; });
        const dismissedAt = Number(read('localStorage', dismissedKey));
        const recentlyDismissed = dismissedAt > 0 && Date.now() - dismissedAt < month;
        const restrictedPage = /\/(?:cart|checkout|checkouts|account|challenge)(?:\/|$)/.test(current.pathname);
        if (dialog.dataset.autoOpen === 'true' && !restrictedPage && !belongsToPopup && !recentlyDismissed && !read('localStorage', completedKey)) {
          autoTimer = window.setTimeout(() => {
            const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
            const activeOverlay = document.querySelector('dialog[open], .menu-drawer-container[open], .somdul-language-inline[open]');
            if (!typing && !activeOverlay && document.visibilityState === 'visible') open();
          }, Number(dialog.dataset.delay || 5) * 1000);
        }
        const sectionElement = dialog.closest('.shopify-section');
        sectionElement?.addEventListener('shopify:section:select', () => open());
        sectionElement?.addEventListener('shopify:section:unload', () => {
          clearTimeout(autoTimer);
          if (dialog.open) dialog.close();
          document.documentElement.classList.remove('somdul-newsletter-open');
          document.querySelectorAll('[data-somdul-popup-open]').forEach((trigger) => { trigger.hidden = true; });
        });
      });
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-somdul-popup-open]');
      const dialog = document.querySelector('[data-somdul-newsletter-popup]');
      if (!trigger || !dialog || !dialog.dataset.initialized) return;
      event.preventDefault();
      dialog.dispatchEvent(new CustomEvent('somdul:newsletter:open', { detail: { trigger } }));
    });
    document.addEventListener('submit', (event) => {
      if (event.target.closest('[data-somdul-newsletter-popup]')) return;
      if (event.target.querySelector('[name="form_type"][value="customer"]')) {
        try { window.sessionStorage.removeItem('somdul:newsletter:attempt:v1'); } catch (_) {}
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
      if (document.querySelector('[data-somdul-newsletter-popup][data-initialized]')) {
        document.querySelectorAll('[data-somdul-popup-open]').forEach((trigger) => { trigger.hidden = false; });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somdul-policy"] && !Shopify.designMode) return;
  try {
    
  function somdulPolicyLanguageReturn() {
    const page = document.querySelector('[data-policy-return]');
    if (!page) return;
    let target;
    try { target = new URL(page.dataset.policyReturn, window.location.origin); } catch (_) { return; }
    if (target.origin !== window.location.origin) return;
    document.querySelectorAll('form[action$="/localization"]').forEach(form => {
      let field = form.querySelector('input[name="return_to"]');
      if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; form.append(field); }
      field.value = target.pathname + target.search;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', somdulPolicyLanguageReturn, {once:true});
  else somdulPolicyLanguageReturn();
  document.addEventListener('shopify:section:load', somdulPolicyLanguageReturn);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somdul-product-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('somdul-product-preview')) {
    customElements.define('somdul-product-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.quantity = this.querySelector('[data-spp-quantity]');
        this.status = this.querySelector('[data-spp-status]');
        this.itemLabels = new Map();
        this.querySelectorAll('[data-spp-item]').forEach(element => this.itemLabels.set(element.dataset.sppItem, element.dataset.label));
        this.querySelectorAll('[data-somdul-sample]').forEach(element => this.itemLabels.set(element.dataset.somdulSample, element.dataset.label || element.textContent.trim()));
        this.item = 'sauce';
        this.querySelectorAll('[disabled]').forEach(element => { element.disabled = false; });
        this.addEventListener('click', event => {
          const target = event.target.closest('button');
          if (!target || !this.contains(target)) return;
          if (target.hasAttribute('data-spp-view')) this.setView(target.dataset.sppView);
          if (target.hasAttribute('data-spp-pack')) this.setPack(target.dataset.sppPack);
          if (target.hasAttribute('data-spp-minus')) this.setQuantity(Number(this.quantity.value) - 1);
          if (target.hasAttribute('data-spp-plus')) this.setQuantity(Number(this.quantity.value) + 1);
          if (target.hasAttribute('data-spp-add')) this.previewSelection();
          if (target.hasAttribute('data-spp-item')) {
            this.updateProduct(target.dataset.sppItem);
            this.status.textContent = this.dataset.itemMessage;
            const title = this.querySelector('h1');
            title.setAttribute('tabindex', '-1');
            title.focus({ preventScroll: true });
            title.scrollIntoView({ behavior: 'instant', block: 'center' });
          }
        });
        this.quantity.addEventListener('change', () => this.setQuantity(this.quantity.value));
        this.quantity.addEventListener('input', () => this.clearSelection());
        let item, pack, quantity;
        try {
          const query = new URLSearchParams(window.location.search);
          item = query.get('item') || window.location.hash.slice(1);
          pack = query.get('pack');
          quantity = Number(query.get('quantity'));
        } catch (error) { item = 'sauce'; }
        this.updateProduct(this.itemLabels.has(item) ? item : 'sauce');
        this.setPack(['single', 'case', 'foodservice'].includes(pack) ? pack : 'single');
        this.setQuantity(Number.isInteger(quantity) && quantity >= 1 && quantity <= 99 ? quantity : 1);
      }
      setView(view) {
        const button = Array.from(this.querySelectorAll('[data-spp-view]')).find(element => element.dataset.sppView === view);
        if (!button) return;
        this.querySelectorAll('[data-spp-view]').forEach(element => element.setAttribute('aria-pressed', String(element === button)));
        this.querySelector('[data-spp-view-label]').textContent = button.dataset.label;
        this.querySelector('[data-spp-photo]').dataset.view = view;
      }
      setPack(pack) {
        const button = Array.from(this.querySelectorAll('[data-spp-pack]')).find(element => element.dataset.sppPack === pack);
        if (!button) return;
        this.querySelectorAll('[data-spp-pack]').forEach(element => element.setAttribute('aria-pressed', String(element === button)));
        this.clearSelection();
        this.syncLocation();
      }
      setQuantity(value) {
        const number = Number(value);
        const amount = Number.isFinite(number) ? Math.max(1, Math.min(99, Math.floor(number))) : 1;
        this.quantity.value = String(amount);
        this.querySelector('[data-spp-minus]').disabled = amount <= 1;
        this.querySelector('[data-spp-plus]').disabled = amount >= 99;
        this.clearSelection();
        this.syncLocation();
        return amount;
      }
      clearSelection() {
        this.querySelector('[data-spp-selection]').hidden = true;
        this.status.textContent = '';
      }
      updateProduct(item) {
        if (!this.itemLabels.has(item)) return;
        this.item = item;
        this.querySelectorAll('[data-spp-title]').forEach(element => { element.textContent = this.itemLabels.get(item); });
        this.setPack('single');
        this.setView('front');
        this.setQuantity(1);
      }
      syncLocation() {
        this.syncCheckoutLink();
        const pack = this.querySelector('[data-spp-pack][aria-pressed="true"]').dataset.sppPack;
        const quantity = this.quantity.value;
        try {
          const current = new URL(window.location.href);
          if (current.searchParams.get('view') === 'product-preview') {
            current.searchParams.set('item', this.item);
            current.searchParams.set('pack', pack);
            current.searchParams.set('quantity', quantity);
            window.history.replaceState(window.history.state, '', current.pathname + current.search + current.hash);
          }
        } catch (error) {}
        document.querySelectorAll('form[id$="LanguageForm"] input[name="return_to"]').forEach(input => {
          try {
            const target = new URL(input.value, window.location.origin);
            if (target.origin === window.location.origin && target.searchParams.get('view') === 'product-preview') {
              target.searchParams.set('item', this.item);
              target.searchParams.set('pack', pack);
              target.searchParams.set('quantity', quantity);
              input.value = target.pathname + target.search;
            }
          } catch (error) {}
        });
      }
      syncCheckoutLink() {
        const link = this.querySelector('[data-spp-checkout]');
        const selected = this.querySelector('[data-spp-pack][aria-pressed="true"]');
        if (!link || !selected || !this.item) return;
        const amount = Math.max(1, Math.min(99, Math.floor(Number(this.quantity.value) || 1)));
        link.setAttribute('href', link.dataset.baseUrl + '&item=' + encodeURIComponent(this.item) + '&pack=' + encodeURIComponent(selected.dataset.sppPack) + '&quantity=' + amount);
      }
      previewSelection() {
        const amount = this.setQuantity(this.quantity.value);
        const name = this.querySelector('h1').textContent;
        const pack = this.querySelector('[data-spp-pack][aria-pressed="true"]').dataset.label;
        this.querySelector('[data-spp-selection-text]').textContent = `${name} · ${pack} × ${amount}`;
        this.querySelector('[data-spp-selection]').hidden = false;
        this.status.textContent = this.dataset.previewMessage;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somdul-wholesale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('somdul-wholesale-preview')) {
    class SomdulWholesalePreview extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.currentStep = 1;
        this.copy = {};
        this.querySelectorAll('[data-copy-key]').forEach((item) => { this.copy[item.dataset.copyKey] = item.textContent.trim(); });
        this.querySelector('[data-controls]').disabled = false;
        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('change', (event) => this.onChange(event));
        this.addEventListener('input', (event) => {
          if (event.target.name) this.clearError(event.target.name);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || event.isComposing) return;
          if (event.target.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="file"])')) {
            event.preventDefault();
            const panel = this.querySelector('[data-panel="' + this.currentStep + '"]');
            const button = panel && panel.querySelector('[data-next], [data-review]');
            if (button) button.click();
          }
        });
        this.addEventListener('submit', (event) => { event.preventDefault(); });
      }

      text(key) { return this.copy[key] || ''; }
      control(name) { return this.querySelector('[name="' + name + '"]'); }
      value(name) { return this.control(name).value.trim(); }
      checked(name) { return this.querySelector('[name="' + name + '"]:checked'); }

      clearError(name) {
        const error = this.querySelector('[data-error="' + name + '"]');
        if (error) { error.textContent = ''; error.hidden = true; }
        this.querySelectorAll('[name="' + name + '"]').forEach((input) => input.removeAttribute('aria-invalid'));
      }

      setError(name, message) {
        const error = this.querySelector('[data-error="' + name + '"]');
        if (error) { error.textContent = this.text(message); error.hidden = false; }
        this.querySelectorAll('[name="' + name + '"]').forEach((input) => input.setAttribute('aria-invalid', 'true'));
      }

      validate(step) {
        const panel = this.querySelector('[data-panel="' + step + '"]');
        panel.querySelectorAll('[data-error]').forEach((error) => this.clearError(error.dataset.error));
        const processed = new Set();
        panel.querySelectorAll('input[required], select[required]').forEach((input) => {
          if (input.disabled || processed.has(input.name)) return;
          processed.add(input.name);
          if (input.type === 'radio') {
            if (!this.checked(input.name)) this.setError(input.name, 'error_choice');
          } else if (!input.value.trim()) {
            this.setError(input.name, 'error_required');
          } else if (input.type === 'email' && !input.validity.valid) {
            this.setError(input.name, 'error_email');
          } else if (input.type === 'tel') {
            const digits = input.value.replace(/\D/g, '');
            if (!/^\+?[\d\s().-]+$/.test(input.value) || digits.length < 10 || digits.length > 15) this.setError(input.name, 'error_mobile');
          }
        });
        if (step === 2 && !this.checked('ingredients')) this.setError('ingredients', 'error_ingredients');
        if (step === 3 && !this.control('permit_later').checked && !this.control('permit_file').files.length) this.setError('permit_file', 'error_file_required');
        const first = panel.querySelector('[aria-invalid="true"]');
        if (first) {
          const alert = this.querySelector('[data-alert]');
          alert.textContent = this.text('error_summary');
          alert.hidden = false;
          if (this.currentStep !== step) this.showStep(step, false);
          first.focus();
          return false;
        }
        return true;
      }

      showStep(step, focus = true) {
        this.currentStep = step;
        this.querySelectorAll('[data-panel]').forEach((panel) => { panel.hidden = Number(panel.dataset.panel) !== step; });
        this.querySelector('[data-back]').hidden = step === 1 || step === 5;
        this.querySelector('[data-back-home]').hidden = step !== 1;
        const progressKey = step < 4 ? 'step_' + step : step === 4 ? 'review_progress' : 'complete_progress';
        this.querySelector('[data-progress-label]').textContent = this.text(progressKey);
        this.querySelectorAll('.sw-progress li').forEach((item, index) => { item.classList.toggle('is-current', index < Math.min(step, 3)); });
        if (focus) {
          const alert = this.querySelector('[data-alert]');
          alert.textContent = '';
          alert.hidden = true;
          this.querySelector('[data-panel="' + step + '"] h1').focus();
        }
      }

      onClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-next')) {
          if (this.validate(this.currentStep)) this.showStep(Number(button.dataset.next));
        } else if (button.hasAttribute('data-back')) {
          this.showStep(Math.max(1, this.currentStep - 1));
        } else if (button.hasAttribute('data-review')) {
          for (const step of [1, 2, 3]) { if (!this.validate(step)) return; }
          this.buildSummary();
          this.showStep(4);
        } else if (button.hasAttribute('data-edit')) {
          this.showStep(Number(button.dataset.edit));
        } else if (button.hasAttribute('data-finish')) {
          this.showStep(5);
        } else if (button.hasAttribute('data-back-review')) {
          this.showStep(4);
        } else if (button.hasAttribute('data-remove-file')) {
          this.control('permit_file').value = '';
          this.updateFile();
          this.clearError('permit_file');
          this.control('permit_file').focus();
        } else if (button.hasAttribute('data-restart')) {
          this.querySelectorAll('input').forEach((input) => {
            if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
            else input.value = '';
          });
          this.querySelectorAll('select').forEach((select) => { select.selectedIndex = 0; });
          this.querySelectorAll('[data-error]').forEach((error) => this.clearError(error.dataset.error));
          this.querySelectorAll('[data-summary]').forEach((summary) => { summary.textContent = ''; });
          this.syncOther();
          this.syncPermitLater();
          this.updateFile();
          this.showStep(1);
        }
      }

      onChange(event) {
        const input = event.target;
        if (input.name) this.clearError(input.name);
        if (input.name === 'ingredients') this.syncOther();
        if (input.name === 'permit_later') this.syncPermitLater();
        if (input.name === 'permit_file') {
          const file = input.files[0];
          let error = '';
          if (file) {
            const supportedMime = ['image/jpeg', 'image/png', 'application/pdf'];
            if (!/\.(jpe?g|png|pdf)$/i.test(file.name) || (file.type && !supportedMime.includes(file.type))) error = 'error_file_type';
            else if (file.size === 0) error = 'error_file_empty';
            else if (file.size > 10 * 1024 * 1024) error = 'error_file_size';
          }
          if (error) { input.value = ''; this.setError('permit_file', error); }
          this.updateFile();
        }
      }

      syncOther() {
        const other = this.querySelector('[name="ingredients"][value="other"]').checked;
        this.querySelector('[data-other-ingredients]').hidden = !other;
        this.control('other_ingredients').disabled = !other;
        if (!other) this.clearError('other_ingredients');
      }

      syncPermitLater() {
        const later = this.control('permit_later').checked;
        this.control('permit_file').disabled = later;
        this.control('permit_number').disabled = later;
        this.querySelector('[data-file-zone]').classList.toggle('is-disabled', later);
        this.clearError('permit_file');
        this.clearError('permit_number');
        this.updateFile();
      }

      updateFile() {
        const file = this.control('permit_file').files[0];
        this.querySelector('[data-selected-file]').hidden = !file || this.control('permit_later').checked;
        this.querySelector('[data-file-name]').textContent = file ? file.name : '';
      }

      optionText(name) {
        const selected = this.checked(name);
        return selected ? selected.nextElementSibling.textContent.trim() : this.text('not_provided');
      }

      buildSummary() {
        const ingredientLabels = Array.from(this.querySelectorAll('[name="ingredients"]:checked')).map((input) => input.value === 'other' ? this.value('other_ingredients') : input.nextElementSibling.textContent.trim());
        const file = this.control('permit_file').files[0];
        const later = this.control('permit_later').checked;
        const groups = {
          1: [['restaurant_name', this.value('restaurant')], ['city', this.value('city')], ['state', this.value('state')], ['restaurant_type', this.optionText('restaurant_type')], ['locations', this.optionText('locations')], ['supplier', this.value('supplier')]],
          2: [['ingredients', ingredientLabels.join(', ')], ['monthly_spend', this.optionText('spend')], ['owner', this.value('owner')], ['mobile', this.value('mobile')], ['email', this.value('email')], ['line', this.value('line')]],
          3: [['permit_file', later ? this.text('provide_later') : file ? file.name + ' — ' + this.text('selected_local') : ''], ['permit_number', later ? this.text('provide_later') : this.value('permit_number')], ['referral', this.value('referral')]]
        };
        Object.entries(groups).forEach(([group, rows]) => {
          const list = this.querySelector('[data-summary="' + group + '"]');
          list.textContent = '';
          rows.forEach(([key, value]) => {
            const row = document.createElement('div');
            const label = document.createElement('dt');
            const detail = document.createElement('dd');
            label.textContent = this.text(key);
            detail.textContent = value || this.text('not_provided');
            row.append(label, detail);
            list.append(row);
          });
        });
      }
    }
    customElements.define('somdul-wholesale-preview', SomdulWholesalePreview);
  }

  } catch(e) { console.error(e); }
})();
})();
